module.exports = __webpack_public_path__ + "static/img-terrence-06f58908abd98a34eac923e055fe6b50.png";